import { CELL_STATE } from '../styles/cellStyles';

export const styles = {
  page: {
    height: '100dvh',
    overflow: 'hidden',
    padding: '20px 16px',
    fontFamily: "'Nunito', 'Inter', system-ui, -apple-system, sans-serif",
    maxWidth: '1000px', margin: '0 auto',
    backgroundColor: '#004f58',
    display: 'flex', flexDirection: 'column',
  },
  cardHeaderRow: {
    display: 'flex', justifyContent: 'space-between',
    marginBottom: '16px', flexShrink: 0,
  },
  cardMeta: {
    fontSize: '13px', color: 'rgba(255,255,255,0.7)',
    fontFamily: "'Nunito Sans', sans-serif",
  },
  clueCard: {
    backgroundColor: '#83C5BE', borderRadius: '8px',
    padding: '16px 20px', marginBottom: '16px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    flexShrink: 0,
  },
  clueCardLabel: {
    fontSize: '10px', color: '#004f58', textTransform: 'uppercase',
    letterSpacing: '1px', marginBottom: '6px',
    fontFamily: "'Nunito Sans', sans-serif", fontWeight: 600,
  },
  clueCardWord: {
    fontFamily: "'Nunito', sans-serif", fontWeight: 900,
    fontSize: '28px', color: '#1B1B2F',
  },
  winPattern: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' },
  winPatternLabel: {
    fontSize: '8px', textTransform: 'uppercase', color: 'rgba(0,79,88,0.65)',
    letterSpacing: '1px', fontWeight: 600, fontFamily: "'Nunito Sans', sans-serif",
  },
  winPatternName: {
    fontSize: '8px', fontWeight: 800, color: '#004f58',
    letterSpacing: '1px', textTransform: 'uppercase', fontFamily: "'Nunito Sans', sans-serif",
  },
  waitingOverlay: {
    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.55)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
  },
  waitingCard: {
    backgroundColor: 'var(--color-background)', borderRadius: '12px',
    padding: '32px 40px', textAlign: 'center', maxWidth: '340px',
    color: 'var(--color-text)', fontWeight: '600', fontSize: '15px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
  },
  winnerBanner: {
    backgroundColor: 'var(--color-accent)', color: '#fff', borderRadius: '12px',
    padding: '16px', marginBottom: '16px', textAlign: 'center',
    fontWeight: '800', fontSize: '22px', boxShadow: 'var(--shadow-bingo)',
    flexShrink: 0,
  },
  endedBanner: {
    backgroundColor: 'var(--color-background)', border: '1px solid var(--color-border)',
    borderRadius: '12px', padding: '14px', marginBottom: '16px', textAlign: 'center',
    color: 'var(--color-text)', fontWeight: '600', fontSize: '16px',
    flexShrink: 0,
  },
  layout: {
    display: 'grid', gridTemplateColumns: '1fr 260px', gridTemplateRows: '1fr',
    gap: '20px', alignItems: 'stretch',
    flex: '1 1 auto', minHeight: 0,
  },
  cardWrap: { userSelect: 'none', display: 'flex', flexDirection: 'column', minHeight: 0 },
  gridWrap: {
    position: 'relative', flex: '1 1 auto', minHeight: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    containerType: 'size',
  },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '4px', width: 'min(100cqw, 100cqh)', aspectRatio: '1' },
  gridLocked: { opacity: 0.55, pointerEvents: 'none' },
  strikeOverlay: {
    position: 'absolute', top: '50%', left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '75%',
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px',
    padding: '16px 20px',
    backgroundColor: 'rgba(255, 240, 244, 0.96)',
    border: '1px solid color-mix(in srgb, var(--color-accent) 35%, transparent)', borderRadius: '14px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.14)',
    pointerEvents: 'none', zIndex: 10,
  },
  invalidBingoOverlay: { width: '90%', padding: '24px 28px' },
  cell: {
    ...CELL_STATE.default,
    aspectRatio: '1', display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    border: '2px solid var(--color-border)',
    borderRadius: '10px', padding: '6px', cursor: 'pointer',
    fontFamily: "'Nunito', 'Inter', system-ui, sans-serif",
    position: 'relative', overflow: 'hidden',
    outline: 'none',
    transition: 'var(--transition-pop)',
    WebkitAppearance: 'none', appearance: 'none',
  },
  cellMarked: {
    ...CELL_STATE.marked,
    boxShadow: 'var(--shadow-marked)', outline: 'none',
  },
  cellWin: {
    ...CELL_STATE.called,
    border: '2px solid #83C5BE',
    boxShadow: 'var(--shadow-bingo)', outline: 'none',
  },
  cellFree: {
    ...CELL_STATE.free,
    border: '2px solid #FF6B6B',
    cursor: 'default',
    boxShadow: 'var(--shadow-marked)', outline: 'none',
  },
  cellLocked: { cursor: 'not-allowed' },
  cellWrong: { cursor: 'not-allowed' },
  cellWord: { fontSize: 'clamp(9px, 1.6vh, 14px)', fontWeight: '600', textAlign: 'center', lineHeight: '1.3' },
  cellWordDef: { fontSize: 'clamp(8px, 1.4vh, 12px)' },
  freeLabel: { fontWeight: '800', fontSize: '14px', color: '#fff' },
  checkmark: {
    position: 'absolute', top: '4px', right: '6px',
    fontSize: '12px', color: 'rgba(255,255,255,0.85)', fontWeight: '800',
  },
  xmark: {
    position: 'absolute', top: '4px', right: '6px',
    fontSize: '12px', color: 'var(--color-destructive)', fontWeight: '800',
  },
  attemptsDots: { display: 'flex', gap: '6px', fontSize: '26px' },
  dotFilled: { color: 'var(--color-destructive)' },
  dotEmpty: { color: 'color-mix(in srgb, var(--color-destructive) 35%, transparent)' },
  attemptsText: { fontSize: '18px', fontWeight: '600', color: 'var(--color-destructive)' },
  sidebar: {
    backgroundColor: 'var(--color-background)', borderRadius: '14px', padding: '20px',
    border: '1px solid var(--color-border)', height: '100%', minHeight: 0, overflowY: 'auto',
    boxShadow: 'var(--shadow-card)',
  },
  sidebarHeading: { fontSize: '14px', fontWeight: '700', color: 'var(--color-text)', margin: '0 0 14px' },
  emptyText: { fontSize: '13px', color: 'var(--color-muted)', fontStyle: 'italic' },
  calledList: { listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '8px' },
  calledItem: {
    display: 'flex', flexDirection: 'column', padding: '8px 10px',
    backgroundColor: 'color-mix(in srgb, var(--color-surface) 15%, var(--color-background))', border: '1px solid var(--color-border)',
    borderRadius: '8px',
  },
  calledWord: { fontSize: '13px', fontWeight: '600', color: 'var(--color-primary)' },
  claimRow: { marginTop: '20px', textAlign: 'center', flexShrink: 0 },
  bingoBtn: {
    width: '100%', backgroundColor: '#FF6B6B',
    color: '#fff', border: 'none', borderRadius: '8px',
    fontFamily: "'Nunito', sans-serif", fontWeight: 800,
    fontSize: '15px', letterSpacing: '1px', padding: '12px',
    cursor: 'pointer',
  },
  newGameBtn: {
    padding: '12px 32px', background: 'var(--color-primary)', color: '#fff',
    border: 'none', borderRadius: '10px', fontSize: '16px', fontWeight: '700',
    cursor: 'pointer', boxShadow: 'var(--shadow-clue)',
  },
  teacherAwayOverlay: {
    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.55)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
  },
  teacherAwayCard: {
    backgroundColor: 'var(--color-background)', borderRadius: 'var(--radius)',
    padding: '40px 48px', textAlign: 'center', maxWidth: '340px',
    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
  },
  teacherAwayIcon: { fontSize: '48px', marginBottom: '16px' },
  teacherAwayTitle: { fontSize: '20px', fontWeight: '700', color: 'var(--color-text)', marginBottom: '8px' },
  teacherAwayText: { fontSize: '15px', color: 'var(--color-muted)', lineHeight: '1.5' },
  disconnectBanner: {
    position: 'fixed', bottom: '20px', left: '50%', transform: 'translateX(-50%)',
    backgroundColor: 'var(--color-destructive)', color: '#fff',
    borderRadius: '10px', padding: '12px 24px', fontWeight: '600', fontSize: '14px', zIndex: 999,
  },
};
